import e from"styled-components";import t from"react";const o=e.div.withConfig({displayName:"PhantomLinkWrapper",componentId:"VDS__sc-1jkunwc-0"})`
  display: ${function({isSelected:e,isDesktop:t}){return e&&t?"inherit":"none"}};
  opacity: 1;
  position: absolute;
  top: ${function({position:e}){return e&&`${e.top+17}px`}};
  left: ${function({position:e}){return e&&`${e.left}px`}};
`,n=function({ctaLink:e,isDesktop:n,isSelected:i,getPosition:s,onMouseEnter:r,onMouseLeave:p,TextLinkCaret:a}){const c=i&&s();return n&&t.createElement(o,{position:c,onMouseEnter:r,onMouseLeave:p,isSelected:i,isDesktop:n},t.createElement(a,Object.assign({ariaHidden:i,disabled:!i},e)))};export{n as default};
